import { render, staticRenderFns } from "./DeliveryTypeTable.vue?vue&type=template&id=6752741b&"
import script from "./DeliveryTypeTable.vue?vue&type=script&lang=js&"
export * from "./DeliveryTypeTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports